import type { WaTemplate, CwContact } from '@/types/templates'

/** Propriedades do payload de contato disponíveis para vincular a uma variável de template. */
export interface TemplatePayloadVar { key: string; label: string; path: keyof CwContact }

export const TEMPLATE_PAYLOAD_VARS: TemplatePayloadVar[] = [
  { key: 'contact_id',    label: 'ID do Contato',       path: 'id' },
  { key: 'contact_name',  label: 'Nome do Contato',     path: 'name' },
  { key: 'contact_phone', label: 'Telefone do Contato', path: 'phone_number' },
  { key: 'contact_email', label: 'Email do Contato',    path: 'email' },
]

/** Exemplo de payload exibido no modal de vínculo (mesmo formato usado na resolução real). */
export const TEMPLATE_PAYLOAD_EXAMPLE = {
  contact: {
    id: 123,
    name: 'João Silva',
    phone_number: '+5511999999999',
    email: 'joao@email.com',
  },
}

export function extractTemplateVarNums(t: WaTemplate): number[] {
  const bodyComp = t.components.find(c => c.type === 'BODY')
  const bodyRaw  = bodyComp?.text || ''
  return [...new Set([...bodyRaw.matchAll(/\{\{(\d+)\}\}/g)].map(m => Number(m[1])))].sort((a, b) => a - b)
}

export function hasTemplateVars(t: WaTemplate): boolean {
  return extractTemplateVarNums(t).length > 0
}

export function resolveTemplateVarValue(varKey: string, contact: CwContact): string {
  const def = TEMPLATE_PAYLOAD_VARS.find(v => v.key === varKey)
  if (!def) return ''
  const val = contact[def.path]
  return val != null ? String(val) : ''
}

// ── Vínculo variável → propriedade do payload: persistência em localStorage ──
export function tplVarMapKey(templateId: string) { return `tpl_var_map_${templateId}` }

export function loadTemplateVarMapping(templateId: string): Record<number, string> {
  try {
    const raw = localStorage.getItem(tplVarMapKey(templateId))
    return raw ? JSON.parse(raw) : {}
  } catch {
    return {}
  }
}

export function saveTemplateVarMapping(templateId: string, mapping: Record<number, string>) {
  const entries = Object.entries(mapping).filter(([, v]) => v)
  if (!entries.length) {
    localStorage.removeItem(tplVarMapKey(templateId))
    return
  }
  localStorage.setItem(tplVarMapKey(templateId), JSON.stringify(Object.fromEntries(entries)))
}
